$(document).ready(function(){
   var currentURL = window.location.href;
        if (currentURL.indexOf("#smile-points-products") >= 0){
         // makeLinkInactive();
      //makePanelInactive();
      $("#alink-size_guide").addClass("active");
      $("#size_guide").addClass("panel_active");
        }
  $("#account_links a").click(function(e){
      e.preventDefault();
      if($(this).hasClass("logout")){
        window.location.href = $(this).data("link");
        var currentURL = window.location.href;
        
      }else{
       /*var currentURL = window.location.href;
  if (currentURL.indexOf("#smile-points-products") >= 0){
        makeLinkInactive();
      makePanelInactive();
      $("#alink-size_guide").addClass("active");
      $("#size_guide").addClass("panel_active");
        }else{*/
             makeAllInactive();
        var div_link = $(this).data("link");
        $(this).addClass("active");
        $("#"+div_link).addClass("panel_active");
        var currentURL = window.location.href;
        if (currentURL.indexOf("#") >= 0){
          var urlSplit = currentURL.split("#");
          var urlNew = urlSplit[0];
          window.history.pushState({}, '', urlNew);
        }
       // }
       
      }
  });
  var currentURL = window.location.href;
  if (currentURL.indexOf("#") >= 0){
    makeLinkInactive();
    makePanelInactive();
    var urlSplit = currentURL.split("#");
    var urlHandle = urlSplit[1];
    $("#alink-"+urlHandle).addClass("active");
    $("#"+urlHandle).addClass("panel_active");
  }
});

function makeAllInactive(){
  $("#account_links").find("a").each(function(){
    if($(this).hasClass("active")){
      $(this).removeClass("active");
    }
  });
  $(".account-container").find(".panel").each(function(){
    if($(this).hasClass("panel_active")){
      $(this).removeClass("panel_active");
    }
  });
}

function makeLinkInactive(){
  $(".alink").each(function(){
    if($(this).hasClass("active")){
      $(this).removeClass("active");
    }
  });
}
function makePanelInactive(){
  $(".account-container").find(".panel").each(function(){
    if($(this).hasClass("panel_active")){
      $(this).removeClass("panel_active");
    }
  });
}

/* URL Change */
let previousUrl = window.location.href;

const observer = new MutationObserver(() => {
  const currentUrl = window.location.href;
  if( currentUrl.indexOf("#smile-points-products") > -1){
    console.log(currentUrl);
    makeLinkInactive();
      makePanelInactive();
      $("#alink-size_guide").addClass("active");
      $("#size_guide").addClass("panel_active");
  
  }
});

observer.observe(document, { subtree: true, childList: true });
